import { createContext } from 'react';

import { Account } from '@lib/types';

interface PageAccountContextValue {
  account?: Account | null;
}

export const PageAccountContext = createContext<PageAccountContextValue>({});
